function getOffsetTimestamp(timeString) {
    const [hours, minutes] = timeString.split(":").slice(0, 2);
    const sumOfMinutes = Number(hours) * 60 + Number(minutes);
    return sumOfMinutes * 60
}

export default getOffsetTimestamp
